import React from "react";
import onsiteproLogo from "../../assets/onsitepro-logo.png";
import "../account/dashboard/dashboard.css";

function FormHeader() {
  return (
    <header className="dashboard-header shadow-sm bg-white border-bottom" style={{padding:'0.7rem 0 0.7rem 0', minHeight:'70px'}}>
      <div className="container-fluid">
        <div className="row align-items-center justify-content-between flex-nowrap">
          <div className="col-8 col-md-auto d-flex align-items-center ps-2 ps-md-3">
            <img src={require('../../assets/logo2 2.png')} alt="Logo" className="img-fluid" style={{height:'48px', width:'auto', objectFit:'contain'}} />
          </div>
          {/* <div className="col-4 col-md-auto d-flex justify-content-end pe-2 pe-md-4">
            <button className="btn d-flex align-items-center justify-content-center" style={{boxShadow:'none', border:'none', color:'#fff', background:'#8b1634', width:'40px', height:'40px', borderRadius:'6px', padding:0}}>
              <i className="fa fa-bars" style={{fontSize:'1.3rem'}}></i>
            </button>
          </div> */}
        </div>
      </div>
    </header>
  );
}

export default FormHeader;
